<!-- <div style="width: 100%; height: 100%;"> -->
<div *ngIf="modalTitle == 'Edit Ams User'" [formGroup]="userForm"
    style="display: flex ; flex: 1;justify-content: flex-start; flex-wrap: wrap; gap: 15px; margin: 40px">
    <h1 style="flex-basis: 100%;">{{modalTitle}}</h1>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>Email</mat-label>
            <input matInput>
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>Registered</mat-label>
            <input matInput>
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>Last Login</mat-label>
            <input matInput>
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>Main Domain</mat-label>
            <input matInput>
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>Company Name</mat-label>
            <input matInput>
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%; display: flex; justify-content: flex-end;">
        <button mat-button (click)="closeModal()" color="accent">Close</button>
        <button mat-button color="primary">Save Changes</button>
    </span>
</div>

<div *ngIf="modalTitle == 'Edit Api User'" [formGroup]="userForm">
    <h1 style="flex-basis: 100%;">{{modalTitle}}</h1>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>User UUID</mat-label>
            <input matInput>
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>Domain UUID</mat-label>
            <input matInput>
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>API Username</mat-label>
            <input matInput>
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>API Key</mat-label>
            <input matInput>
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>Carrier Contact UUID</mat-label>
            <input matInput>
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>Driver Contact UUID</mat-label>
            <input matInput>
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>Shipper Contact UUID</mat-label>
            <input matInput>
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>Consignee Contact UUID</mat-label>
            <input matInput>
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>Customer Contact UUID</mat-label>
            <input matInput>
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%; display: flex; justify-content: flex-end;">
        <button mat-button (click)="closeModal()" color="accent">Close</button>
        <button mat-button color="primary">Save Changes</button>
    </span>
</div>

<div *ngIf="modalTitle == 'Edit Phone System'" [formGroup]="phoneForm"
    style="display: flex ; flex: 1;justify-content: flex-start; flex-wrap: wrap; gap: 15px; margin: 40px">
    <h1 style="flex-basis: 100%;">{{modalTitle}}</h1>
    <span style="flex-basis: 100%;">
        <mat-form-field hidden="true" style="width: 80%;">
            <mat-label>User UUID</mat-label>
            <input matInput formControlName="user_id">
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>Domain</mat-label>
            <input matInput formControlName="domain">
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>API Key</mat-label>
            <input matInput formControlName="api_key">
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>Extensions</mat-label>
            <input matInput formControlName="extensions">
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>Active Extension</mat-label>
            <input matInput formControlName="active_extension">
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>Gateway</mat-label>
            <input matInput formControlName="gateway">
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>Caller ID Name</mat-label>
            <input matInput formControlName="caller_id_name">
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 80%;">
            <mat-label>Caller ID Number</mat-label>
            <input matInput formControlName="caller_id_number">
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%; display: flex; justify-content: flex-end;">
        <button mat-button (click)="closeModal()" color="accent">Close</button>
        <button mat-button (click)="updatePhoneSystem()" color="primary">Save Changes</button>
    </span>
</div>

<div *ngIf="modalTitle == 'Add Domain Access'" [formGroup]="domainAccessForm"
    style="display: flex ; flex: 1;justify-content: flex-start; flex-wrap: wrap; gap: 15px; margin: 40px">
    <h1 style="flex-basis: 100%;">{{modalTitle}}</h1>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 100%;">
            <mat-label>Domain</mat-label>
            <mat-select formControlName="domain" style="width: 100%;">
                <mat-option *ngFor="let type of domainList" [value]="type.domain_uuid">
                    {{type.domain_name}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 100%;">
            <mat-label>API Username</mat-label>
            <input matInput formControlName="api_username">
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%;">
        <mat-form-field style="width: 100%;">
            <mat-label>API Group</mat-label>
            <mat-select formControlName="api_group" (selectionChange)="onSelectionShipperAddress($event)"
                style="width: 100%;">
                <mat-option *ngFor="let type of apiGroupList" [value]="type">
                    {{type}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </span>
    <span style="flex-basis: 100%; display: flex; justify-content: flex-end;">
        <button mat-button (click)="closeModal()" color="accent">Close</button>
        <button mat-button (click)="updatePhoneSystem()" color="primary">Save Changes</button>
    </span>
</div>
<!-- </div> -->

<div *ngIf="modalTitle == 'Add New User'" [formGroup]="userForm"
    style="display: flex ; flex: 1;justify-content: flex-start; flex-wrap: wrap; gap: 15px; margin: 20px">
    <input formControlName="shipper_company_name" type="text" hidden="true">
    <input formControlName="shipper_contact_uuid" type="text" hidden="true">
    <input formControlName="consignee_company_name" type="text" hidden="true">
    <input formControlName="consignee_contact_uuid" type="text" hidden="true">
    <input formControlName="customer_company_name" type="text" hidden="true">
    <input formControlName="customer_contact_uuid" type="text" hidden="true">
    <input formControlName="carrier_company_name" type="text" hidden="true">
    <input formControlName="carrier_contact_uuid" type="text" hidden="true">
    <input formControlName="ams_side_menu_array" type="text" hidden="true">
    <input formControlName="ams_side_sub_menu_array" type="text" hidden="true">
    <h1 style="font-weight: bold; font-size: 24px; text-align: center">{{modalTitle}}</h1>
    <!-- <input formControlName="username" style="display:none" type="text" > -->
    <input style="display:none" type="password">
    <div class="section-cards">
        <mat-card class="card">
            <mat-card-header>
                <mat-card-title>AMS User Credentials</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <span style="flex-basis: 100%;">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Email Address</mat-label>
                        <input matInput formControlName="email" (blur)="onEmailStoppedEditing($event)">
                    </mat-form-field>
                </span>
                <span style="flex-basis: 100%;">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Password</mat-label>
                        <input matInput formControlName="password" type="password">
                    </mat-form-field>
                </span>
                <span style="flex-basis: 100%;">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Confirm Password</mat-label>
                        <input matInput formControlName="confirm_password" type="password">
                    </mat-form-field>
                </span>
            </mat-card-content>
        </mat-card>
        <mat-card class="card">
            <mat-card-header>
                <mat-card-title>Company Information</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <span style="flex-basis: 100%;">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Role</mat-label>
                        <mat-select formControlName="role" (selectionChange)="onSelectionShipperAddress($event)"
                            style="width: 100%;">
                            <mat-option *ngFor="let type of roleList" [value]="type.role.toLowerCase()">
                                {{type.role}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </span>
                <span style="flex-basis: 100%;">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Company Name</mat-label>
                        <input matInput formControlName="company">
                    </mat-form-field>
                </span>
            </mat-card-content>
        </mat-card>
        <mat-card class="card">
            <mat-card-header>
                <mat-card-title>API Account Information</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <span style="flex-basis: 100%;">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Domain</mat-label>
                        <mat-select formControlName="domain" (selectionChange)="updateContacts()"
                            style="width: 100%;">
                            <mat-option *ngFor="let type of domainList" [value]="type.domain_uuid">
                                {{type.domain_name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </span>
                <span style="flex-basis: 100%;">
                    <mat-form-field style="width: 100%;">
                        <mat-label>API Username</mat-label>
                        <input matInput formControlName="api_username">
                    </mat-form-field>
                </span>
                <span style="flex-basis: 100%;">
                    <mat-form-field style="width: 100%;">
                        <mat-label>API Group</mat-label>
                        <mat-select formControlName="api_groups" (selectionChange)="updateContacts()" [multiple]="true" style="width: 100%;">
                            <mat-option *ngFor="let type of apiGroupList" [value]="type.toLowerCase()">
                                {{ type }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </span>
                <span style="flex-basis: 100%;">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Contact Organization</mat-label>
                        <input matInput [matAutocomplete]="autoComplete" formControlName="contact"
                            placeholder="Start typing contact name...">
                        <mat-autocomplete #autoComplete="matAutocomplete">
                            <mat-option *ngFor="let item of filteredContactList | async" [value]="item">
                                <span>{{ item }}</span>
                            </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </span>
            </mat-card-content>
        </mat-card>
        <mat-card class="card">
            <mat-card-header>
                <mat-card-title>Other Information</mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <span style="flex-basis: 100%;">
                    <mat-form-field style="width: 100%;">
                        <mat-label>Messaging</mat-label>
                        <mat-select formControlName="messaging" (selectionChange)="onSelectionShipperAddress($event)"
                            style="width: 100%;">
                            <mat-option *ngFor="let type of messagingList" [value]="type.id">
                                {{type.status}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </span>
                <span style="flex-basis: 100%;">
                    <input #fileInput type="file" style="display: none" (change)="onFileSelected($event)">
                    <button (click)="selectFile()" mat-button color="primary">Select Avatar</button>
                </span>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="form-submition-container">
        <div class="form-buttons">
            <button mat-button (click)="closeModal()" color="accent">Close</button>
            <button mat-button (click)="createUser()" color="primary">Save</button>
        </div>
    </div>
</div>